<template>
  <div>
    <page-header :title="$t('bill.analysis_report')" />
    <page-body>
      <analysis-report-list id="AnalysisReportList" />
    </page-body>
  </div>
</template>

<script>
import AnalysisReportList from './components/List'

export default {
  name: 'AnalysisReportIndex',
  components: {
    AnalysisReportList,
  },
  data () {
    return {}
  },
}
</script>
